import React from "react";

/** CDN pipeline live health — segment count, DVR cover, latest segments feed. */
export default function CdnPipelinePanel({ cdn, pipelineHealth, pipelineSegments }) {
  return (
    <>
          {/* CDN pipeline live health */}
          <div className="border-t border-zinc-800 pt-4" data-testid="cdn-pipeline-section">
            <div className="flex items-baseline justify-between mb-2">
              <div className="font-display font-bold">CDN pipeline · live</div>
              <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
                Refresh 3s · asyncio worker
              </span>
            </div>
            {pipelineHealth ? (
              <div className="border border-zinc-800 rounded-sm bg-black/40 p-3 font-mono text-[11px] space-y-2" data-testid="pipeline-health-card">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className={`px-2 py-0.5 rounded-sm text-[10px] font-bold ${
                    pipelineHealth.worker_running
                      ? "bg-emerald-500/10 text-emerald-400 border border-emerald-500/40"
                      : "bg-zinc-700/40 text-zinc-400 border border-zinc-700"
                  }`}>
                    {pipelineHealth.worker_running ? "● WORKER LIVE" : "○ WORKER IDLE"}
                  </span>
                  <span className="text-zinc-500">state <span className="text-zinc-100">{pipelineHealth.publish_state}</span></span>
                  <span className="text-zinc-500">variants <span className="text-emerald-400">{pipelineHealth.variants.join(" · ")}</span></span>
                </div>
                <div className="grid grid-cols-4 gap-2 text-xs">
                  <div>
                    <div className="text-[9px] text-zinc-500 uppercase tracking-widest">Rate</div>
                    <div className="text-emerald-400">{pipelineHealth.segs_per_min}/min</div>
                  </div>
                  <div>
                    <div className="text-[9px] text-zinc-500 uppercase tracking-widest">Egress</div>
                    <div className="text-emerald-400">{pipelineHealth.egress_mbps} Mb/s</div>
                  </div>
                  <div>
                    <div className="text-[9px] text-zinc-500 uppercase tracking-widest">Upload lat</div>
                    <div className="text-emerald-400">{pipelineHealth.avg_upload_latency_ms} ms</div>
                  </div>
                  <div>
                    <div className="text-[9px] text-zinc-500 uppercase tracking-widest">DVR cover</div>
                    <div className="text-emerald-400">
                      {Math.round(pipelineHealth.dvr_covered_sec / 60)}/{Math.round(pipelineHealth.dvr_window_sec / 60)}m
                    </div>
                  </div>
                </div>
                <div className="text-zinc-500">
                  Total published: <span className="text-zinc-300">{pipelineHealth.total_segments_published?.toLocaleString?.() || 0}</span> segments ·{" "}
                  <span className="text-zinc-300">
                    {((pipelineHealth.total_bytes_published || 0) / (1024 * 1024)).toFixed(1)} MiB
                  </span>
                </div>
                {pipelineHealth.last_error && (
                  <div className="text-red-400">error: {pipelineHealth.last_error}</div>
                )}
                {pipelineSegments.length > 0 && (
                  <div className="pt-2 border-t border-zinc-800">
                    <div className="text-[9px] text-zinc-500 uppercase tracking-widest mb-1">Recent segments</div>
                    <div className="space-y-0.5 max-h-40 overflow-y-auto scrollbar-thin">
                      {pipelineSegments.map((s) => (
                        <div key={`${s.sequence}-${s.variant}`} className="flex items-center gap-2 text-[10px]" data-testid={`pipeline-seg-${s.sequence}-${s.variant}`}>
                          <span className="text-zinc-500 w-14">seq {String(s.sequence).padStart(5, "0")}</span>
                          <span className="text-emerald-400 w-12">{s.variant}</span>
                          <span className="text-zinc-500 w-16">{Math.round(s.size_bytes / 1024)} KB</span>
                          <span className="text-zinc-500 w-14">{s.upload_latency_ms} ms</span>
                          <span className="text-zinc-600 truncate flex-1" title={s.origin_url}>{s.origin_url}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="text-xs text-zinc-500 italic">Loading pipeline telemetry…</div>
            )}
          </div>

    </>
  );
}
